import { CompanyType } from '@api';
import { t } from 'i18next';
import z from 'zod';

export const companyFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: t('companyDetailsGeneral:FORM_ERRORS.NAME_REQUIRED') }),
  shortName: z.string(),
  website: z.string(),
  tags: z.array(z.string()),
  notes: z.string(),
  vatId: z.string(),
});

export type CompanyFormSchemaType = z.infer<typeof companyFormSchema>;

export type UseCompanyFormSchemaReturnType = {
  schema: typeof companyFormSchema;
  defaultValues: CompanyFormSchemaType;
};

export const useCompanyFormSchema = (
  company: CompanyType
): UseCompanyFormSchemaReturnType => {
  const defaultValues: CompanyFormSchemaType = {
    name: company.name,
    shortName: company.shortName ?? '',
    website: company.website ?? '',
    tags: company.tags,
    notes: company.notes ?? '',
    vatId: company.vatId ?? '',
  };

  return {
    schema: companyFormSchema,
    defaultValues,
  };
};
